<template>
  <Drawer
    width="600"
    title="权责修改申请表"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
        :loading="customerLoading"
      >
        <div class="form-content">
          <div class="form-left">
            <FormItem label="客户" prop="customer" style="width: 250px">
              <Input v-model="currentCustomerQz.name"></Input>
            </FormItem>
            <FormItem label="开发 40%" prop="dev">
              <div class="distribution-item-update" v-for="(item, index) in devList" :key="item.id">
                <Select 
                  placeholder="选择人员"
                  style="width: 120px;margin-right: 16px"
                  @on-select="selectedUser($event, index, 'devList')"
                  filterable 
                  v-model="item.user._id"
                  clearable>
                  <Option v-for="uu in userList" :value="uu._id" :key="uu._id">{{ uu.name }}</Option>
                </Select>
                <InputNumber placeholder="比例" @on-blur='devRatioRule' :max="100" :min="1" v-model="item.ratio" />%
              </div>
              <Button type="info" ghost @click="addRow('devList')">添加一行</Button>
            </FormItem>
            <FormItem label="维护 30%" prop="maintain">
              <div class="distribution-item-update" v-for="(item, index) in maintainList" :key="item.id">
                <Select 
                  placeholder="选择人员"
                  style="width: 120px;margin-right: 16px"
                  @on-select="selectedUser($event, index, 'maintainList')"
                  filterable 
                  v-model="item.user._id"
                  clearable>
                  <Option v-for="uu in userList" :value="uu._id" :key="uu._id">{{ uu.name }}</Option>
                </Select>
                <InputNumber placeholder="比例" @on-blur='maintainRatioRule' :max="100" :min="1" v-model="item.ratio" />%
              </div>
              <Button type="info" ghost @click="addRow('maintainList')">添加一行</Button>
            </FormItem>
            <FormItem label="回款 30%" prop="payment">
              <div class="distribution-item-update" v-for="(item, index) in paymentList" :key="item.id">
                <Select 
                  placeholder="选择人员"
                  style="width: 120px;margin-right: 16px"
                  @on-select="selectedUser($event, index, 'paymentList')"
                  filterable 
                  v-model="item.user._id"
                  clearable>
                  <Option v-for="uu in userList" :value="uu._id" :key="uu._id">{{ uu.name }}</Option>
                </Select>
                <InputNumber placeholder="比例" @on-blur='paymentRatioRule' :max="100" :min="1" v-model="item.ratio" />%
              </div>
              <Button type="info" ghost @click="addRow('paymentList')">添加一行</Button>
            </FormItem>
          </div>
          <div class="form-right">
            <FormItem label="区域经理" prop="regionalCharger" style="width: 250px">
              <Select 
                  placeholder="选择人员"
                  style="width: 120px"
                  filterable 
                  v-model="formItem.regionalCharger"
                  clearable>
                  <Option v-for="uu in userList" :value="uu._id" :key="uu._id">{{ uu.name }}</Option>
                </Select>
            </FormItem>
            <FormItem label="销售可见人" prop="salesVisibleMember" style="width: 250px">
              <Select 
                  placeholder="选择人员"
                  multiple
                  filterable 
                  v-model="formItem.salesVisibleMember"
                  clearable>
                  <Option v-for="uu in userList" :value="uu._id" :key="uu._id">{{ uu.name }}</Option>
                </Select>
            </FormItem>
            <FormItem label="技术可见人" prop="techVisibleMember" style="width: 250px">
              <Select 
                  placeholder="选择人员"
                  multiple
                  filterable 
                  v-model="formItem.techVisibleMember"
                  clearable>
                  <Option v-for="uu in userList" :value="uu._id" :key="uu._id">{{ uu.name }}</Option>
                </Select>
            </FormItem>
          </div>
        </div>
        
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "CustomerQZUpdateFormDrawer",
  data() {
    return {
      drawerOpened: false,
      customerLoading: false,
      formItem: {
        customer: null,
        regionalCharger: null,
      },
      ruleValidate: {
        customer: [
          { required: true, message: "客户为必填项", trigger: "submit" },
        ],
      },
      currentCustomerQz: {
        name: null,
      },
      customerSearchText: null,
      devList:[
        {
          id: 0,
          ratio: 0,
          user: {
            name: null,
            _id: null,
          },
        },
      ],
      maintainList: [
        {
          id: 0,
          ratio: 0,
          user: {
            name: null,
            _id: null,
          },
        }
      ],
      paymentList: [
        {
          id: 0,
          ratio: 0,
          user: {
            name: null,
            _id: null,
          },
        }
      ],
      isDevRule: true,
      isMaintainRule: true,
      isPaymentRule: true,
    };
  },
  computed: {
    ...mapState({
      customersSimple: (state) => state.customer.customersSimple,
      userList: (state) => state.user.simpleUserList,
    }),
  },
  methods: {
    ...mapActions({
      getCustomerSimpleList: "customer/getCustomerSimpleListAction",
      getCustomerQZById: "customer/getCustomerQZByIdAction",
      createCustomerQZUpdateForm: "customerQZUpdateForm/createCustomerQZUpdateFormAction",
      getSimpleUserList: "user/getSimpleUserListAction",
    }),
    async openDrawer(data) {
      const customerQz = data.row
      this.drawerOpened = true;
      this.formItem = {
        customer: null,
      }
      this.currentCustomerQz = {
        name: null,
      }
      this.devList = [
        {
          id: 0,
          ratio: 0,
          user: {
            name: null,
            _id: null,
          },
        },
      ]
      this.maintainList = [
        {
          id: 0,
          ratio: 0,
          user: {
            name: null,
            _id: null,
          },
        },
      ]
      this.paymentList = [
        {
          id: 0,
          ratio: 0,
          user: {
            name: null,
            _id: null,
          },
        },
      ]
      if (data) {
        this.currentCustomerQz = data.row
        this.formItem.customer = data.row._id
        this.formItem.regionalCharger = data.row?.regionalCharger?._id
        this.formItem.salesVisibleMember = data.row?.salesVisibleMember.map(x => x._id)
        this.formItem.techVisibleMember = data.row?.techVisibleMember.map(x => x._id)
        if (customerQz.comissionDivDev?.length > 0) {
          this.devList = customerQz.comissionDivDev.map(x=> {
            const obj = {...x} // 防止修改原数组。当map修改引用对象的时候会修改原数组
            obj.ratio = obj.ratio*100
            return obj
          })
        }
        if (customerQz.comissionDivMaintain?.length > 0) {
          this.maintainList = customerQz.comissionDivMaintain.map(x=> {
            const obj = {...x} // 防止修改原数组。当map修改引用对象的时候会修改原数组
            obj.ratio = obj.ratio*100
            return obj
          })
        }
        if (customerQz.comissionDivPayment?.length > 0) {
          this.paymentList = customerQz.comissionDivPayment.map(x=> {
            const obj = {...x} // 防止修改原数组。当map修改引用对象的时候会修改原数组
            obj.ratio = obj.ratio*100
            return obj
          })
        }
        
      }
    },
    async selectedUser(item, index, list) {
      if (item) {
        const user = {
          name: item.label,
          _id: item.value
        }
      this[list][index].user = user
      }
    },
    addRow (list) {
      const baseDistribution = {
        id: 0,
        ratio: 0,
        user: {
          name: null,
          _id: null,
        },
      }
      baseDistribution.id = this[list].length
      this[list].push(baseDistribution)
    },
    devRatioRule() {
      const ratio = this.devList.map(x => x.ratio).reduce((pre, cur) => {
        return pre + cur
      },0)
      if (ratio > 40) {
        this.$Message.error({
          content: '开发分配比例总和不得大于40%',
          closable: true,
          duration: 0,
        });
        this.isDevRule = false
      }else{
        this.isDevRule = true
      }
    },
    maintainRatioRule() {
      const ratio = this.maintainList.map(x => x.ratio).reduce((pre, cur) => {
        return pre + cur
      },0)
      if (ratio > 30) {
        this.$Message.error({
          content: '维护分配比例总和不得大于30%',
          closable: true,
          duration: 0,
        });
        this.isMaintainRule = false
      }else{
        this.isMaintainRule = true
      }
    },
    paymentRatioRule() {
      const ratio = this.paymentList.map(x => x.ratio).reduce((pre, cur) => {
        return pre + cur
      },0)
      if (ratio > 30) {
        this.$Message.error({
          content: '回款分配比例总和不得大于30%',
          closable: true,
          duration: 0,
        });
        this.isPaymentRule = false
      }else{
        this.isPaymentRule = true
      }
    },
    async handleSubmit(name) {
      if (this.isDevRule && this.isMaintainRule && this.isPaymentRule) {
      }else{
        this.$Message.error({
          content: '请按规定分配比例',
          closable: true,
          duration: 0,
        });
        return
      }
      this.devList.map(v => {
        delete v.id
        delete v.user.name
        v.ratio = v.ratio / 100
      })
      this.formItem.comissionDivDev = this.devList.filter(x => x.user._id)
      this.formItem.devSales = this.devList.map(v => v.user._id)
      this.maintainList.map(v => {
        delete v.id
        delete v.user.name
        v.ratio = v.ratio / 100
      })
      this.formItem.comissionDivMaintain = this.maintainList.filter(x => x.user._id)
      this.formItem.maintainSales = this.maintainList.map(v => v.user._id)
      this.paymentList.map(v => {
        delete v.id
        delete v.user.name
        v.ratio = v.ratio / 100
      })
      this.formItem.comissionDivPayment = this.paymentList.filter(x => x.user._id)
      this.formItem.paymentSales = this.paymentList.map(v => v.user._id)
      
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            await this.createCustomerQZUpdateForm(this.formItem)
            this.drawerOpened = false;
            this.$Message.success('修改成功');
          } catch (error) {
            
          }
        }
      })
    },
  },
  async created() {
    await this.getSimpleUserList({ limit: 99 });
    await this.getCustomerSimpleList();
  },
};
</script>
<style lang="stylus" scoped>
.distribution-item-update
  margin-bottom 16px
.form-content
  display flex
  .form-left
    margin-right 40px
</style>